/**
 * Shared storage key constants for scenes/dineout full payment flow.
 * Used by both dineout-cart-client and payment-client packages.
 */

/** Key to identify if the current flow is a scenes full payment flow */
export const SCENES_FULL_PAYMENT_FLOW_KEY = "isScenesFullPaymentFlow";

/** Key to store the order ID for scenes full payment flow */
export const SCENES_FULL_PAYMENT_ORDER_ID_KEY = "scenesFullPaymentOrderId";
